import { render, staticRenderFns } from "./ZhanhuiAreaStatBlock.vue?vue&type=template&id=94b275ac&scoped=true"
import script from "./ZhanhuiAreaStatBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiAreaStatBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiAreaStatBlock.vue?vue&type=style&index=0&id=94b275ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b275ac",
  null
  
)

export default component.exports